(function (ws) {
    'use strict';
    /**
     * @typedef {Object} Event - DOM Event object
     */
    ws.views.modal = ws.views.googleAnalytics.extend({

        events: {
            'click .close-button': 'closeModal',
            'click .modal-container': 'closeModal',
            'click .modal-close': 'closeModal',
            'click [data-event="close"]': 'closeModal',
            'click [data-event="continue"]': 'continue',
            'click [data-event="clearall"]': 'clearall'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.moveModal();

            // Run some validation checks on the modal ID
            this.modalId = this.$el.attr('id');
            this.validateID(this.modalId);

            ws.views.modal.modalIDs.push(this.modalId);

            $('body').on('click', '[data-event="' + this.modalId + '"]', this.onOpen.bind(this));
            this.eventAgg.on(this.modalId, this.onOpen.bind(this));
            this.eventAgg.on(this.modalId + 'close', this.onClose.bind(this));
            this.disableClose = Boolean(this.$el.attr('data-disable-close') === 'true');
            this.allInputs = $(':input');
            this.$buttons = this.$('button').not('.crt-next-button, .qup-save');

            this.$modalOverlay = $('.modal-overlay-default');

            if (!this.$modalOverlay.hasClass('show')) {
                westcon.modalInTransition.resolve();
            }

            //if data-init property in calling object is true, open the modal immediately.
            if (this.$el.data('init') === true) {
                this.onOpen();
            }

            // close modal on clicks outside body
            this.$el.on('click', function (ev) {
                if ($(ev.target).hasClass('modal-container')) {
                    this.onClose(ev);
                }
            }.bind(this));

        },

        /**
         * Move the location of the modal to just after the body
         * so it doesn't interfere with other component styling/functionality.
         */
        moveModal() {
            const body = document.querySelector('body');
            body.insertBefore(this.$el[0], body.firstChild);
        },

        /**
         * Checks for a unique modal ID;
         * throws an Error if it's a duplicate or empty.
         * @param {string} id
         * @throws {Error}
         */
        validateID: function(id) {
            if (!id) {
                /* [ES6]: change maxLength to const */
                var maxLength = 300;
                var errorMessage = 'Modal ID cannot be blank:\n';
                errorMessage += this.$el[0].outerHTML.substring(0, maxLength);
                if (this.$el[0].outerHTML.length > maxLength) {
                    errorMessage += '...';
                }

                console.error(errorMessage);
            } else if (ws.views.modal.modalIDs.indexOf(id) !== -1) {
                console.warn('Modal ID ' + id + ' has already been used.');
            }
        },

        /**
         * On Modal Open
         * @param {Object} ev
         */
        onOpen: function (ev) {
            if (this.isAlreadyOpen()) {
                console.debug('Modal ID: ' + this.modalId + ' is already opened.');
                return;
            }

            if (ev) {
                ev.preventDefault();
            }

            this.trigger('onOpen');
            this.render();
        },

        /**
         * Check if the modal is already open to not open it twice
         *
         * @returns {boolean}
         */
        isAlreadyOpen: function () {
            return this.$el.is(':visible');
        },

        /**
         * On Modal Close
         * @param {boolean} force
         */
        onClose: function (force) {
            // If `force` is an event object, it's because the modal was closed by
            // clicking outside of the modal body.
            var ev = (typeof force === 'object') ? force : undefined;
            if (!this.disableClose || (typeof force === 'boolean' && force)) {
                this.trigger('onClose');
                this.closeModal(ev);
            }
        },

        /**
         * Render Modal
         */
        render: function () {
            westcon.modalInQueue++;
            westcon.modalInTransition.done(function () {
                westcon.modalInQueue--;
                $('body').addClass('noScroll');
                this.$modalOverlay.addClass('show');
                westcon.modalInTransition = $.Deferred();
            }.bind(this));
            this.$el.fadeIn(100);
        },

        /**
         * Close Modal
         */
        closeModal: function () {
            this.$el.fadeOut('fast', function () {
                if (westcon.modalInQueue === 0) {
                    this.$modalOverlay.removeClass('show');
                }

                westcon.modalInTransition.resolve();
            }.bind(this));

            $('body').removeClass('noScroll');
            this.allInputs.removeClass('error');
            this.$buttons.prop('disabled', false);
            this.$buttons.removeClass('spinner-before no-padding');
            this.$('.error-message').hide();
            this.$('.error').hide();

            this.eventAgg.trigger(this.modalId + 'OnClose');
        },

        clearall: function () {
            $('.threeplinboundcreatform')[0].reset();
            $('.ponumbers-list').remove();
            $('.poFiles-list').remove();
            $('.required-error-message').hide();
            this.closeModal();
        },

        /**
         * Continue
         */
        continue: function () {
            this.eventAgg.trigger(this.modalId + 'continue');
            this.closeModal();
        }
    },
    {
        /**
         * All used modal IDs.
         * @static
         * @property {string[]}
         */
        modalIDs: []
    });
})(westcon);
